import "./Block17COtherMoniesFieldsTable.css";

import { CircularProgress, useTheme } from "@mui/material";
import { FC, useEffect, useState } from "react";

import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";

let block17COtherMoniesDDLData = [
  { label: "--", value: null },
  { label: "Bonus (Holiday)", value: "B05" },
  { label: "Bonus (Production/Incentive)", value: "B06" },
  { label: "Bonus (Event)", value: "B07" },
  { label: "Bonus (Staying/Contract complete/End of season)", value: "B08" },
  { label: "Bonus (Separation or retirement)	", value: "B09" },
  { label: "Bonus (Closure)", value: "B10" },
  { label: "Bonus (Other)", value: "B11" },
  { label: "Severance pay", value: "E00" },
  { label: "Gratuities", value: "G00" },
  { label: "Honorariums", value: "H00" },
  { label: "Sick leave credits", value: "BI0005" },
  { label: "Retroactive pay adjustment", value: "J00" },
  { label: "Other", value: "O00" },
  { label: "Profit sharing", value: "Q00" },
  { label: "Retiring allowance/Retirement leave credits", value: "R00" },
  { label: "Settlement pay", value: "S00" },
  { label: "Payout of banked overtime", value: "T00" },
  {
    label: "SUB Maternity/Parental/Compassionate Care/Family Caregiver",
    value: "U12",
  },
  { label: "SUB Layoff", value: "U13" },
  { label: "SUB Illness", value: "U14" },
  { label: "SUB Training", value: "U15" },
  { label: "Pay in lieu of notice", value: "Y00" },
];
let columns = [
  { field: "otherMonies" },
  { field: "startDate" },
  { field: "endDate" },
  { field: "amount" },
  { field: "addToBlock15bC" },
];
interface IBlock17COtherMoniesFieldsTable {
  block17COtherMoniesUpdatedData: (data: any) => void;
  block17COtherMoniesDataItems: any;
}
export const Block17COtherMoniesFieldsTable: FC<
  IBlock17COtherMoniesFieldsTable
> = ({ block17COtherMoniesUpdatedData, block17COtherMoniesDataItems }) => {
  const [block17COtherMonies, setBlock17COtherMonies] = useState<any>(
    block17COtherMoniesDataItems
  );

  useEffect(() => {
    block17COtherMoniesUpdatedData(block17COtherMonies);
  }, [block17COtherMonies]);

  useEffect(() => {

    setBlock17COtherMonies(block17COtherMoniesDataItems);
  }, [block17COtherMoniesDataItems]);

  const onCellValueChange = (event: any, rowIndex: number, field: any) => {

    setBlock17COtherMonies((prev: any) => {
      const updatedData = [...prev];

      const updatedRow = { ...updatedData[rowIndex], [event.field]: field };

      updatedData[rowIndex] = updatedRow; // ✅ Replace with new object (triggers re-render)
      return updatedData;
    });
  };

  const renderErrorClass = (field: any, rowIndex: number, rowData: any) => {
    if (field.field === "startDate") {
      if (
        rowData.block17COtherMonies !== "" &&
        rowData.block17COtherMonies !== undefined &&
        rowData.block17COtherMonies !== null
      ) {
        if (rowData.startDate === null) {
          return "p-component p-filled calender-error-input";
        } else if (rowData.startDate === "") {
          return "p-component p-filled calender-error-input";
        }
      }
    } else if (field.field === "block17COtherMonies") {
      if (
        rowData.startDate !== "" &&
        rowData.startDate !== undefined &&
        rowData.startDate !== null
      ) {
        if (rowData.block17COtherMonies === null) {
          return "p-component p-filled input-dropdown-fields .p-dropdown dropdown-error-input";
        } else if (rowData.block17COtherMonies === "") {
          return "p-component p-filled input-dropdown-fields .p-dropdown dropdown-error-input";
        }
      } else {
        return "p-component p-filled input-dropdown-fields .p-dropdown";
      }
    } else {
      return "p-component p-filled input-dropdown-fields";
    }
  };

  const columnsBody = (rowData: any, row: any, x: any) => {
    if (x.field === "otherMonies") {
      return (
        <Dropdown
          options={block17COtherMoniesDDLData}
          value={rowData[x.field]}
          onChange={(e: any) =>
            onCellValueChange(x, row.rowIndex, e.target.value)
          }
          placeholder="--"
          className={renderErrorClass(x, row.rowIndex, rowData)}
          optionLabel="label"
          optionValue="value"
          style={{ borderRadius: "2px", width: "300px" }}
        />
      );
    } else if (x.field === "startDate") {
      return (
        <Calendar
          id="startDate"
          value={rowData[x.field]}
          showIcon
          // className="calender"
          style={{ height: "2.6rem", margin: "8px 0px 4px 0px", width: "auto" }}
          onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
          dateFormat="M dd, yy"
          showButtonBar
          className={`calender ${renderErrorClass(x, row.rowIndex, rowData)}`}
        />
      );
    } else if (x.field === "endDate") {
      return (
        <Calendar
          id="endDate"
          value={rowData[x.field]}
          showIcon
          className="calender"
          style={{ height: "2.6rem", margin: "8px 0px 4px 0px", width: "auto" }}
          onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
          dateFormat="M dd, yy"
          showButtonBar
        />
      );
    } else if (x.field === "addToBlock15bC") {
      return (
        <>
          <Checkbox
            inputId="addToBlock15bC"
            name="addToBlock15bC"
            value={rowData[x.field]}
            onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.checked)}
            checked={rowData[x.field]}
          />
          <label htmlFor="addToBlock15bC" className="ml-2">
            Add to block 15B/15C
          </label>
        </>
      );
    } else if (x.field === "amount") {
      return (
        <InputNumber
          value={rowData[x.field]}
          onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
          placeholder="0.00"
          minFractionDigits={2}
          maxFractionDigits={2}
          inputStyle={{ textAlign: "right", borderRadius: "2px" }}
        />
      );
    }
  };



  return (
    <>
      <DataTable
        value={block17COtherMonies}
        dataKey="id"
        showGridlines
        className="Block17COtherMoniesTab"
        editMode="cell"
        resizableColumns
        columnResizeMode="expand"
        scrollable
        // reorderableColumns
        filterDisplay="menu"
        scrollHeight="516px"
      >
        {columns.map((x: any, index: any) => {
          return (
            <Column
              key={index}
              field={x.field}
              columnKey={x.field}
              style={{
                fontSize: "0.875rem",
              }}
              body={(rowData: any, row: any) => columnsBody(rowData, row, x)}
            />
          );
        })}
      </DataTable>
    </>
  );
};
